/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-9450cd75.js';
import '@carbon/icon-helpers';
import 'vue';

const ShoppingCartArrowDown16 = createSVGComponent('ShoppingCartArrowDown16', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 32 32",
  "fill": "currentColor",
  "width": 16,
  "height": 16
}, [{
  "elem": "circle",
  "attrs": {
    "cx": "10",
    "cy": "28",
    "r": "2"
  }
}, {
  "elem": "circle",
  "attrs": {
    "cx": "24",
    "cy": "28",
    "r": "2"
  }
}, {
  "elem": "path",
  "attrs": {
    "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  }
}, {
  "elem": "path",
  "attrs": {
    "d": "M21.586 6.586L18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z"
  }
}]);

export { ShoppingCartArrowDown16 as default };
